import type { ContactDetail } from '../../../../core/data-sources/content-components/types.js';

import { console } from '../../../../core/system/console/index.js';

export const getContact = (
  contacts: ContactDetail[],
  type: string,
): string | false => {
  const contact = contacts.find((c) => c.type === type);

  if (type === 'instagram' && !contact) {
    const otherContact = contacts.find(
      (c) => c.type === 'other' && c.value.includes('instagram'),
    );

    return otherContact ? otherContact.value : false;
  }

  return contact ? contact.value : false;
};

export const extractUsernameFromLink = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    const pathSegments = parsedUrl.pathname.split('/');
    const username = pathSegments[1];

    return username;
  } catch (error) {
    console.error('Invalid URL:', error);

    return url;
  }
};

export const stripTrailingNumbers = (url: string) => {
  return url.replace(/-\d+$/, '');
};
